import { getAdminProxy } from "@/api";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Navigate, Outlet } from "react-router";

const AdminProxyGuard = () => {
    const { data: adminProxy } = useSuspenseQuery({
        queryKey: ["getAdminProxy"],
        queryFn: getAdminProxy,
    });

    // If the current admin has an organization context, redirect to organizations
    if (adminProxy.has_organization_context) {
        return <Navigate to="/organizations" replace />;
    }

    // If the admin does not have an organization context, continue to the requested route
    return <Outlet />;
};

export default AdminProxyGuard;
